import { Button, Modal, Row } from 'antd';
import { FC } from 'react';

type ModalProps = {
  confirmButtonLabel?: string;
  confirmButtonAction: () => void;
  denyButtonLabel?: string;
  denyButtonAction: () => void;
  titleLabel: string;
  messageLabel: string | React.ReactNode;
  showModal: boolean;
  icon?: React.ReactNode;
  hideCloseButtonHeader?: boolean;
  isDangerConfirmButton?: boolean;
  isLoading?: boolean;
  isCentered?: boolean;
  hideDenyButton?: boolean;
};

export const ModalAlert: FC<ModalProps> = ({
  confirmButtonLabel = 'Confirmar',
  denyButtonLabel = 'Cancelar',
  confirmButtonAction,
  denyButtonAction,
  showModal,
  titleLabel,
  messageLabel,
  icon,
  hideCloseButtonHeader,
  isDangerConfirmButton,
  isLoading = false,
  isCentered = false,
  hideDenyButton = false,
}) => {
  const IsCancellationButton = () => {
    return (
      <>
        {!hideDenyButton && (
          <Button
            data-testid='modal-alert-deny-button'
            onClick={denyButtonAction}
            disabled={isLoading}
          >
            {denyButtonLabel}
          </Button>
        )}
        <Button
          data-testid='modal-alert-confirm-button'
          type='primary'
          danger={isDangerConfirmButton}
          onClick={confirmButtonAction}
          loading={isLoading}
        >
          {confirmButtonLabel}
        </Button>
      </>
    );
  };

  const titleWithIcon = (
    <Row align='middle' style={{ gap: 8 }}>
      {icon}
      <span>{titleLabel}</span>
    </Row>
  );

  return (
    <Modal
      title={icon ? titleWithIcon : titleLabel}
      open={showModal}
      centered={isCentered}
      onCancel={denyButtonAction}
      footer={[IsCancellationButton()]}
      closable={!hideCloseButtonHeader}
    >
      {messageLabel}
    </Modal>
  );
};
